// Import model
import { LookupFieldOptions } from '../models/LookupFieldOptions';

// Import base class serializer
import { FieldOptionsSerializer } from './FieldOptionsSerializer';

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for LookupFieldOptions - handles JSON serialization and deserialization with type validation
 */
export class LookupFieldOptionsSerializer {
  /**
   * Deserializes a JSON string into a LookupFieldOptions instance
   */
  static deserialize(json: string): LookupFieldOptions {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a LookupFieldOptions instance
   */
  static fromObject(obj: any): LookupFieldOptions {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to LookupFieldOptions');
    }


    const instance: LookupFieldOptions = {
      t: obj['_t'] as string,
      linkUrl: obj['LinkUrl'] as string | undefined,
      linkLabel: obj['LinkLabel'] as string | undefined,
      _4D1Cded3: obj['_4d1cded3'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of LookupFieldOptions instances
   */
  static deserializeArray(json: string): LookupFieldOptions[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a LookupFieldOptions instance to a JSON string
   */
  static serialize(instance: LookupFieldOptions): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a LookupFieldOptions instance to a plain object
   */
  static toObject(instance: LookupFieldOptions): any {
    return {
      '_t': instance.t,
      'LinkUrl': instance.linkUrl,
      'LinkLabel': instance.linkLabel,
      '_4d1cded3': instance._4D1Cded3,
    };
  }

  /**
   * Serializes an array of LookupFieldOptions instances to a JSON string
   */
  static serializeArray(instances: LookupFieldOptions[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
